/**
 * 平台类型判断工具类
 * 根据"来源网站"、"媒体类型"和"发布者性质"进行三级判断
 */

export interface JudgePlatformTypeParams {
  sourceSite?: string;
  mediaType?: string;
  publisherType?: string;
}

/**
 * 判断平台类型
 * @param params - 参数对象
 * @returns 平台类型字符串
 */
export function judgePlatformType({ sourceSite, mediaType, publisherType }: JudgePlatformTypeParams): string {
  // 第一步：根据"来源网站"进行过滤判断
  if (sourceSite) {
    const sourceSiteTrimmed = sourceSite.trim();
    
    // 抖音
    if (sourceSiteTrimmed === '抖音') {
      return '抖音';
    }
    
    // 快手
    if (sourceSiteTrimmed === '快手') {
      return '快手';
    }
    
    // 小红书
    if (sourceSiteTrimmed === '小红书') {
      return '小红书';
    }
    
    // 微头条和今日头条
    if (sourceSiteTrimmed === '微头条' || sourceSiteTrimmed === '今日头条') {
      return '今日头条';
    }
    
    // 新浪微博/新浪长微博/新浪微博视频
    if (sourceSiteTrimmed === '新浪微博' || 
        sourceSiteTrimmed === '新浪长微博' || 
        sourceSiteTrimmed === '新浪微博视频') {
      return '微博';
    }
    
    // 微信
    if (sourceSiteTrimmed === '微信') {
      return '微信';
    }
    
    // 知乎问答/知乎问题/知乎专栏/知乎想法
    if (sourceSiteTrimmed === '知乎问答' || 
        sourceSiteTrimmed === '知乎问题' || 
        sourceSiteTrimmed === '知乎专栏' || 
        sourceSiteTrimmed === '知乎想法') {
      return '知乎';
    }
    
    // 微信视频号
    if (sourceSiteTrimmed === '微信视频号') {
      return '视频号';
    }
    
    // bilibili/好看视频/度小视/微视
    if (sourceSiteTrimmed === 'bilibili' || 
        sourceSiteTrimmed === '好看视频' || 
        sourceSiteTrimmed === '度小视' || 
        sourceSiteTrimmed === '微视') {
      return '短视频';
    }
  }
  
  // 第二步：对第一步筛选后的数据，根据"媒体类型"进行过滤判断
  if (mediaType) {
    const mediaTypeTrimmed = mediaType.trim();
    
    // 媒体类型为论坛/贴吧
    if (mediaTypeTrimmed === '论坛' || mediaTypeTrimmed === '贴吧') {
      return '贴吧论坛';
    }
    
    // 媒体类型为报刊
    if (mediaTypeTrimmed === '报刊') {
      return '平媒';
    }
  }
  
  // 第三步：对第一步和第二步筛选后的数据，根据"发布者性质"进行过滤判断
  if (publisherType) {
    const publisherTypeTrimmed = publisherType.trim();
    
    // 发布者性质为自媒体
    if (publisherTypeTrimmed === '自媒体') {
      return '自媒体';
    }
    
    // 其余的发布者性质
    return '网媒';
  }
  
  // 如果所有参数都为空，默认返回网媒
  return '网媒';
}

